export const dragScroll = () => {
    const slider = document.querySelector('.about-us-section .slider');
    const sliderWrapper = document.querySelector('.about-us-section .slider-wrapper');
    const leftBtn = document.querySelector('.about-us-section .slider-btn-left');
    const rightBtn = document.querySelector('.about-us-section .slider-btn-right');
    const slides = document.querySelectorAll('.about-us-section .slide');

    if (!slider || !sliderWrapper || !leftBtn || !rightBtn || !slides.length) {
        return;
    }

    let currentIndex = 0;

    const isMobile = () => window.matchMedia('(max-width: 767.98px)').matches;

    const getVisibleSlides = () => (isMobile() ? 1 : Math.min(3, slides.length));

    const getStep = () => {
        const slide = slides[0];
        const styles = window.getComputedStyle(sliderWrapper);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return slide.getBoundingClientRect().width + gap;
    };

    const maxIndex = () => Math.max(0, slides.length - getVisibleSlides());

    const goTo = (index) => {
        currentIndex = Math.max(0, Math.min(index, maxIndex()));
        sliderWrapper.style.transform = `translateX(-${currentIndex * getStep()}px)`;
    };

    rightBtn.addEventListener('click', () => {
        goTo(currentIndex + 1);
    });

    leftBtn.addEventListener('click', () => {
        goTo(currentIndex - 1);
    });

    window.addEventListener('resize', () => {
        goTo(Math.min(currentIndex, maxIndex()));
    }, { passive: true });
};
